/**
 * Line icons local to the billing feature (pricing cards, usage, success
 * toast). `currentColor`-driven so Cendre tokens control the hue; sized via
 * `className`. Kept here so the feature stays self-contained.
 */
export interface IconProps {
  className?: string;
}

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
} as const;

export function CheckIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}
